import Carousel from 'react-bootstrap/Carousel';
import banner1 from "assets/tg/banner01.png";
import banner2 from "assets/tg/banner02.png";
import banner3 from "assets/tg/banner03.png";

export const Carouseltg = () => {
  return (
    <Carousel>
      <Carousel.Item interval={3000}>
        <img
          className="d-block w-100"
          src= {banner1}
          alt="First slide"
          
        />
        
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <img
          className="d-block w-100"
          src={banner2}
          alt="Second slide"
        />
        
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <img
          className="d-block w-100"
          src={banner3}
          alt="Third slide"
        />
        
      </Carousel.Item>
      
      
    </Carousel>
  );
}
